import { render } from "./modal-detail.vue?vue&type=template&id=7f8901b1"
import script from "./modal-detail.vue?vue&type=script&lang=js"
export * from "./modal-detail.vue?vue&type=script&lang=js"

import "./modal-detail.vue?vue&type=style&index=0&id=7f8901b1&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/ALL_REPO/Web-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__